import { EventEmitter } from '@bikemap/js/utility'

/**
 * Base class for map features.
 */
export default class MapFeature extends EventEmitter {

    /** @type {import("maplibre-gl").Map} */
    _map = null

    /**
     * Add this feature to a map instance.
     * This should only be called by a map instance! If you are composing map
     * functionality, please use map.addFeature(feature) instead.
     * @param {import("maplibre-gl").Map} map
     */
    addTo(map) {
        this._map = map
        this._onAdd(map)
    }

    /**
     * Remove this feature from the map.
     */
    remove() {
        this._onRemove(this._map)
        this._map = null
    }

    /**
     * Called when this feature is added to the map.
     * It can be delayed if map itself is not yet loaded.
     * @param {import("maplibre-gl").Map} map
     * @private
     */
    _onAdd(map) {}

    /**
     * Called when this feature is removed from the map.
     * @param {import("maplibre-gl").Map} map
     * @private
     */
    _onRemove(map) {}

}
